import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FormatService {

  constructor() { }

  numberWithCommas(x) {
    // console.log('x to format is: ' ,x)
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

}
